import { createSlice, PayloadAction, Reducer } from '@reduxjs/toolkit';
import { RootState } from '../../../../@types/RootState';
import { RESET_EXTRACTION_FILTERS_CACHE, SET_EXTRACTION_FILTERS_CACHE_BY_KEY } from '../filters/cache';
import { RESET_EXTRACTION_FILTERS_QUERIES, SET_EXTRACTION_FILTERS_QUERIES_BY_KEY } from '../filters/queries';
import { RESET_EXTRACTION_FILTERS_VALUE, SET_EXTRACTION_FILTERS_VALUE_BY_KEY } from '../filters/values';

export type ExtractionPaginationState = {
  activePage: number;
  displayLength: number;
  total: number;
  lengthMenu: Record<'label' | 'value', number>[];
};

const lengthMenu: ExtractionPaginationState['lengthMenu'] = [
  {
    value: 20,
    label: 20,
  },
  {
    value: 40,
    label: 40,
  },
];

const initialState: ExtractionPaginationState = {
  activePage: 1,
  displayLength: lengthMenu[0].value,
  total: 0,
  lengthMenu,
};

const slice = createSlice({
  name: 'ipa.extraction.table.datapoints',
  initialState,
  reducers: {
    RESET_EXTRACTION_DATAPOINTS: () => initialState,
    UPDATE_EXTRACTION_PAGE: (state, action: PayloadAction<number>) => {
      return { ...state, activePage: action.payload };
    },
    UPDATE_EXTRACTION_PAGE_SIZE: (state, action: PayloadAction<number>) => {
      return { ...state, displayLength: action.payload };
    },
    UPDATE_EXTRACTION_TOTAL: (state, action: PayloadAction<number>) => {
      return { ...state, total: action.payload };
    },
  },
  extraReducers: builder => {
    builder
      .addCase(SET_EXTRACTION_FILTERS_QUERIES_BY_KEY, state => {
        state.activePage = 1;
      })
      .addCase(RESET_EXTRACTION_FILTERS_QUERIES, state => {
        state.activePage = 1;
      })
      .addCase(SET_EXTRACTION_FILTERS_VALUE_BY_KEY, state => {
        state.activePage = 1;
      })
      .addCase(RESET_EXTRACTION_FILTERS_VALUE, state => {
        state.activePage = 1;
      })
      .addCase(SET_EXTRACTION_FILTERS_CACHE_BY_KEY, state => {
        state.activePage = 1;
      })
      .addCase(RESET_EXTRACTION_FILTERS_CACHE, state => {
        state.activePage = 1;
      });
  },
});

export const { RESET_EXTRACTION_DATAPOINTS, UPDATE_EXTRACTION_PAGE, UPDATE_EXTRACTION_PAGE_SIZE, UPDATE_EXTRACTION_TOTAL } = slice.actions;

const reducer: Reducer<ExtractionPaginationState> = slice.reducer;

export default reducer;

export const selectorExtractionPagination = (state: RootState) => {
  return state.ipa.extraction.table.pagination;
};
